/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState, useEffect, useRef } from 'react'

interface FeedbackStateProps {
  isOpen: boolean
  message: string
  statusOk: boolean
  title?: string
  timeout?: number
  type?: string
  visible?: boolean
  semTitulo?: boolean
}

const initialFeedback: FeedbackStateProps = {
  isOpen: false,
  message: '',
  statusOk: false,
  title: undefined,
  timeout: 5000
}

interface FeedbackContextProps {
  feedback: FeedbackStateProps
  setFeedback: React.Dispatch<React.SetStateAction<FeedbackStateProps>>
  setNewCompanies?: React.Dispatch<React.SetStateAction<number>>
}

export const FeedbackContext = createContext<FeedbackContextProps>({
  feedback: initialFeedback,
  setFeedback: () => {}
})

export const FeedbackProvider: React.FC<any> = ({ children }) => {
  const [feedback, setFeedback] = useState(initialFeedback)
  const [newCompanies, setNewCompanies] = useState(0)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (feedback.isOpen) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      const timeout = feedback.timeout || 5000
      
      timeoutRef.current = setTimeout(() => {
        setFeedback(prev => ({ ...prev, isOpen: false }))
      }, timeout)

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }
      }
    }
  }, [feedback.isOpen, feedback.timeout])

  return (
    <FeedbackContext.Provider
      value={{
        feedback,
        setFeedback,
        setNewCompanies
      }}
    >
      {children}
    </FeedbackContext.Provider>
  )
}
